
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class DecisionPointGroupBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class DecisionPointGroupBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:        string = data._id.match(/^dpg-(.*)/i)[1];
    const pieces: string[] = data._id.split(/@@/);
    const dpid:     number = parseInt(pieces[1].match(/(\d+)$/)[1]);

    return {
      id:          data._id,
      seq:         parseInt(data.seq),
      index:       args.index,
      name:        `${data.n} mi ${data.m} - ${data.tm}`,
      dp:          data.n,
      hasChildren: args.hasChildren,
      isExpanded:  args.isExpanded,
      type:        'decision-point-group',
      children:    args.children,
      parent:      args.parent,
      depart:      null,
      kids:        data.ch,
      tags:        data.tg,
      label:       data.lb,
      pkey:        data.pa,
      mileage:     data.m,
      time:        data.tm,
      dpid,
      u
    };

  }
}
